<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from 'vue'
import UpArrowIcon from '~/assets/icons/arrows/24/arrow-up-black.svg?component'

const props = defineProps<{
  isVisible?: boolean
}>()
const showButton = ref(false)

const handleScroll = () => {
  showButton.value = window.scrollY > window.innerHeight
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
  <div v-if="props.isVisible" v-show="showButton">
    <div class="button-scroll" @click="scrollToTop">
      <UpArrowIcon />
    </div>
  </div>
</template>
<style scoped lang="scss">
.button-scroll {
  position: fixed;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: $control-content_white;
  box-shadow: 0 4px 20px 0 #00000014;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 40px;
  right: 40px;
  z-index: 100;
  transition: background-color 0.3s ease, transform 0.2s ease;

  @include md-breakpoint {
    bottom: 88px;
    right: 10px;
  }
}

.button-scroll:hover {
  transform: scale(1.1);
}
</style>
